const autoRunConstants = require('./autorun');
const splitDeliveryConstants = require('./split-delivery');
const pickListValidationConstants = require('./picklist-validation');
const optimaAutoIndentConstants = require('./auto-indent');
const optimaSOBConstants = require('./sob');
const combineTypeConstants = require('./combine-type');

module.exports = {
  displayName: 'OPTIMA',
  description: 'Optimize Pickups',
  sortOrder: 2,
  name: 'optima',
  documentKey: 'optima_settings',
  displayColorClass: 'borderfill-teal-light',
  sections: {
    optimaAutomation: {
      displayName: 'Optima Automation',
      description: 'Optima automation',
      sortOrder: 1,
      name: 'optimaAutomation',
      configurations: {
        autoRun: autoRunConstants,
        optimaAutoIndent: optimaAutoIndentConstants,
        combineType: combineTypeConstants,
        splitDelivery: splitDeliveryConstants,
      },
    },
    materialsForOptima: {
      displayName: 'Materials for Optima',
      description: 'Optima automation',
      sortOrder: 2,
      name: 'optimaAutomation',
      configurations: {
        pickListValidationWithMaster: pickListValidationConstants,
      },
    },
    sob: {
      displayName: 'SOB',
      description: 'SOB',
      sortOrder: 3,
      name: 'sob',
      configurations: {
        optimaSOB: optimaSOBConstants,
      },
    },
  },
};
